<template>
  <div class="container">
    <div class="column-left">
      <TeamLeaderboard v-if="isUserOnTeam" />
    </div>
    <transition name="fade">
      <div class="column-center" v-if="show">
        <JoinGameComponent />
        <StartGameComponent />
        <RecentGamesComponent v-if="isUserOnTeam" />
      </div>
    </transition>
    <div class="column-center spinner-top-padded" v-if="!show">
      <Spinner color="teal" />
    </div>
    <div class="column-right">
      <ProfileComponent v-if="isUserOnTeam" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import TeamLeaderboard from '@/components/teamHomeComponents/TeamLeaderboard';
import RecentGamesComponent from '@/components/teamHomeComponents/RecentGamesComponent';
import JoinGameComponent from '@/components/teamHomeComponents/JoinGameComponent';
import StartGameComponent from '@/components/teamHomeComponents/StartGameComponent';
import ProfileComponent from '@/components/teamHomeComponents/ProfileComponent';
import Spinner from '@/components/utilComponents/Spinner';

export default Vue.extend({
  name: 'TeamHomeView',
  components: {
    TeamLeaderboard,
    RecentGamesComponent,
    JoinGameComponent,
    StartGameComponent,
    ProfileComponent,
    Spinner
  },
  data: () => ({
    show: false,
    isUserOnTeam: false
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    async checkUserIsOnTeam() {
      const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/checkuserisonteam`, {
        auth0UserId: this.auth0UserId
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });

      this.isUserOnTeam = response.data.isUserOnTeam || false;
    }  
  },
  created: async function () {
    await this.checkUserIsOnTeam();
    this.show = true;
  }
})
</script>

<style scoped lang="scss">
.container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: $dark-brown;
  min-height: min-content;
  padding-top: 6em;
  padding-bottom: 10em;
  margin: 0 10em;
}
</style>
